import { render, staticRenderFns } from "./TrendingItems.vue?vue&type=template&id=bbd460e2&scoped=true&"
import script from "./TrendingItems.vue?vue&type=script&lang=js&"
export * from "./TrendingItems.vue?vue&type=script&lang=js&"
import style0 from "./TrendingItems.vue?vue&type=style&index=0&id=bbd460e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd460e2",
  null
  
)

export default component.exports